export default function NotFound() {
  return (
    <>
      <h1 style={{ color: "black" }}>This page is not found</h1>
    </>
  );
}
